// extracted by css-extract-rspack-plugin
export default {"title":"title-Y0Y8dO"};